export const GET_VAR_DATA = "GET_VAR_DATA";
